import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.5 6.89248C17.5 6.23878 17.1456 5.63646 16.5742 5.319L10.8742 2.15233C10.3305 1.85031 9.66948 1.85031 9.12584 2.15233L3.42584 5.319C2.85441 5.63646 2.5 6.23878 2.5 6.89248V13.1076C2.5 13.7613 2.85441 14.3636 3.42584 14.681L9.12584 17.8477C9.66948 18.1497 10.3305 18.1497 10.8742 17.8477L16.5742 14.681C17.1456 14.3636 17.5 13.7613 17.5 13.1076V6.89248ZM10 12.7778C11.5943 12.7778 12.8868 11.5341 12.8868 10C12.8868 8.4659 11.5943 7.22224 10 7.22224C8.40569 7.22224 7.11325 8.4659 7.11325 10C7.11325 11.5341 8.40569 12.7778 10 12.7778Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }